import { z } from 'zod';
import { BondTradeBaseSchema } from './bond';

export const BOND_WORKBOOK_TABS = ['pretrade', 'entry', 'approval', 'coupon_schedule', 'settlement', 'valuation', 'stp', 'history'] as const;
export type BondWorkbookTab = (typeof BOND_WORKBOOK_TABS)[number];

export const BondDealWorkbookPayloadSchema = z.object({
  /** Existing deal to load. When present, tabs 2–5 are unlocked. */
  deal_id: z.string().min(1).optional(),
  /** Tab to activate on open. Defaults to 'entry'. */
  tab: z.enum(BOND_WORKBOOK_TABS).optional(),
  /** Agent prefill values for the entry form (new deal path). */
  prefill: BondTradeBaseSchema.partial().optional(),
});

export type BondDealWorkbookPayload = z.infer<typeof BondDealWorkbookPayloadSchema>;
